import { z } from 'zod';

import { isoDateTimeSchema, uuidSchema } from './common.js';

export const notificationSchema = z.object({
  id: uuidSchema,
  workspaceUserId: uuidSchema,
  event: z.string(),
  title: z.string(),
  body: z.string(),
  url: z.string().nullable(),
  taskId: z.string().nullable(),
  readAt: isoDateTimeSchema.nullable(),
  createdAt: isoDateTimeSchema,
});

export type NotificationDto = z.infer<typeof notificationSchema>;
